const DocumentProcessingStatus = Object.freeze({
    UPLOADED: 'uploaded',
    CREATED: 'created',
    ANALYSIS_PENDING: 'analysis_pending',
    ANALYSIS_COMPLETED: 'analysis_completed',
    REVIEW_PENDING: 'review_pending',
    COMPLETED: 'completed',
    REJECTED: 'rejected',
    FAILED: 'failed',
})

const POLLING_STATUSES = Object.freeze([
    DocumentProcessingStatus.CREATED,
    DocumentProcessingStatus.ANALYSIS_PENDING,
    DocumentProcessingStatus.ANALYSIS_COMPLETED,
])

const ANALYSIS_PROCESSING_STATUSES = Object.freeze([
    DocumentProcessingStatus.CREATED,
    DocumentProcessingStatus.ANALYSIS_PENDING,
    DocumentProcessingStatus.ANALYSIS_COMPLETED,
])

const getDocumentProcessingStatus = document => (
    document && document.processing && document.processing.status
        ? document.processing.status
        : DocumentProcessingStatus.UPLOADED
)

const getDocumentReviewProcessId = document => (
    document && document.processing && document.processing.reviewProcessId
        ? document.processing.reviewProcessId
        : null
)

const shouldPollDocument = document => {
    const status = getDocumentProcessingStatus(document)

    return POLLING_STATUSES.includes(status)
}

const isDocumentAnalysisProcessing = document => (
    ANALYSIS_PROCESSING_STATUSES.includes(getDocumentProcessingStatus(document))
)

export {
    DocumentProcessingStatus,
    getDocumentProcessingStatus,
    getDocumentReviewProcessId,
    isDocumentAnalysisProcessing,
    shouldPollDocument,
}
